<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
        <a-modal @cancel="cancelShouhuo" :visible="visible_shouhuo" :maskClosable="false" :width="700" @ok="handleOk">
            <!-- 请输入退货数量<a-input-number :min="0" type="number" style="width:100px" /> -->
            <a-row class="form-row" :gutter="24" style="margin-top:20px">
                <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                    <a-form-item label="商品规格：">
                        【编号】：{{ list.skuSn }} 【品牌】：{{ list.brandName }} 【规格】：{{ list.specification }}【数量】：{{ list.quantity }}
                    </a-form-item>
                    <a-form-item label="可退数量：">
                        {{list.returnNumNew? (list.quantity - list.returnNumNew):list.quantity }}
                    </a-form-item>
                    <a-form-item label="退货数量：">
                        <a-input-number :min="0" v-model="orderList.returnNum" :max="list.quantity" type="number" style="width:70%" />
                    </a-form-item>
                    <a-form-item label="选择售后原因：">
                        <a-select v-model="orderList.reason" style="width:70%">
                            <a-select-option value="质量问题">
                                质量问题
                            </a-select-option>
                            <a-select-option value="特殊需求">
                                特殊需求
                            </a-select-option>
                            <a-select-option value="使用问题">
                                使用问题
                            </a-select-option>
                            <a-select-option value="破损问题">
                                破损问题
                            </a-select-option>
                            <a-select-option value="包装问题">
                                包装问题
                            </a-select-option>
                            <a-select-option value="运输丢失">
                                运输丢失
                            </a-select-option>
                            <a-select-option value="数量短少">
                                数量短少
                            </a-select-option>
                            <a-select-option value="其他问题">
                                其他问题
                            </a-select-option>
                            <a-select-option value="仪器维修">
                                仪器维修
                            </a-select-option>
                            <a-select-option value="破损丢失">
                                破损丢失
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                <!-- <a-col :lg="24" :md="24" :sm="24">
                    <a-form-item>
                        <div class="goods_table_base_left1">选择服务类型：</div>
                        <a-select v-model="orderList.type" style="width:70%">
                            <a-select-option value="REFUNDS_RETURNS">
                                我要退款（无需退货）没收到货，或与卖家协商同意不用退货只退款
                            </a-select-option>
                            <a-select-option value="ONLY_REFUNDS">
                                我要退货退款 已收到货，需要退还收到的货物
                            </a-select-option>
                            <a-select-option value="EXCHANGE_GOODS">
                                我要换货 已收到货，需要更换已收到的货物
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col> -->
                    <a-form-item label="上传图片：">
                        <a-upload action="/api/file/upload" list-type="picture-card" :file-list="fileList" @preview="handlePreview" @change="handleChange" style="width:70%">
                            <div v-if="fileList.length < 4">
                                <a-icon type="plus" />
                                <div class="ant-upload-text">
                                    点击上传
                                </div>
                            </div>
                        </a-upload>
                        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                            <img alt="example" style="width: 100%" :src="previewImage" />
                        </a-modal>
                    </a-form-item>
                    <a-form-item label="问题描述：">
                        <a-textarea placeholder="请输入退货原因" v-model="orderList.description" :rows="4" style="width:70%" />
                    </a-form-item>
                </a-form>
            </a-row>
        </a-modal>
        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="12" />
            <div class="box5">
                <div style="display:flex">
                <div class="title">申请售后：退款/退换货---订单编号：{{ order_data.orderSn }}</div>
                <div style="margin-left: 20px;color:red">
                    每一个订单最多只支持一次售后（订单退换）
                </div>
                </div>
                <!-- <div style="overflow: hidden" :key="index" v-for="(item, index) in order_data.ordersItemList">
                    <img v-if="item.cover" :src="'/api/file/preview/' + item.cover" style=" height: 90px; float: left;margin-top:5px" alt="" />
                    <img v-else src="../assets/pro-default-img@2x.png" alt="" style=" height: 90px; float: left;margin-top:5px" />
                    <div style="float: left; margin: 0px 0 10px 20px">
                        <div class="goods_title1" style=";margin-top:5px">
                            <span style="width:200px;display: inline-block;">{{ item.productName }} CAS号：{{ item.casNum }}</span>
                            <span style="width:180px;display: inline-block;margin-left:60px;color:#bbb;color: #2b9a34">退货数量：{{ item.afterSale.returnNum }}</span>
                            <span style="width:260px;display: inline-block;;color:#bbb;color: #2b9a34">退货原因：{{ item.afterSale.reason }}</span>
                            <span class="tijiao1" @click="updated(item, index)">修改</span>
                        </div>
                        <div class="goods_title1" style="color: #666;margin-top:20px">详细：【编号】{{ item.skuSn }} 【品牌】{{ item.brandName }} 【包装】{{ item.packaging }}【规格】{{ item.specification }}【数量】{{ item.quantity }}</div>
                    </div>
                </div> -->
                <div :key="index" v-for="(item, index) in order_data.ordersItemList" class="list">
                    <img v-if="item.cover" :src="'/api/file/preview/' + item.cover" style="width:72px; height: 90px;margin-top:5px" alt="" />
                    <img v-else src="../assets/pro-default-img@2x.png" alt="" style="width:72px; height: 90px;margin-top:5px" />
                    <div class="text">
                        <div class="list-top">
                            <div class="name">{{ item.productName }}</div>
                            <div class="CAS">CAS号：{{ item.casNum }}</div>
                        </div>
                        <div class="list-center">详细：【编号】{{ item.skuSn }} 【品牌】{{ item.brandName }} 【包装】{{ item.packaging }}【规格】{{ item.specification }}【数量】{{ item.quantity }}</div>
                        <div class="list-bottom">
                            <div style="width:120px;">退货数量：{{ item.afterSale.returnNum }}</div>
                            <div style="width:176px;">退货原因：{{ item.afterSale.reason }}</div>
                            <div style="width:540px" class="unwape">问题描述：{{ item.afterSale.description }}</div>
                        </div>
                    </div>
                    <div class="tijiao1" @click="updated(item, index)">选择原因</div>
                </div>
                <!-- <div
                    style="
            width: 100%;
            height: 1px;
            margin: 20px 0;
            border-bottom: 1px dashed #ede9e9;
          "
                ></div> -->
                <!-- <div class="title">选择服务类型</div>
        <div class="title" style="margin-top:20px;font-size: 12px">选择化学品售后原因</div>
        <div>
            <a-checkbox-group
              v-model="value"
              name="checkboxgroup"
              :options="plainOptions"
              @change="onChange"
              style="margin-top:10px"
            />
        </div>
        <div class="title" style="margin-top:10px;font-size: 12px">仪器耗材售后原因</div>
        <div>
            <a-checkbox-group
              v-model="value1"
              name="checkboxgroup"
              :options="options"
              @change="onChange1"
              style="margin-top:10px"
            />
        </div>
        <div style="overflow: hidden">
          <div
            @click="type = 0"
            :class="[type == 0 ? 'xuanzhong' : '']"
            style="
              overflow: hidden;
              margin-top: 20px;
              float: left;
              cursor: pointer;
            "
          >
            <div style="width: 320px; height: 80px; border: 1px solid #ede9e9">
              <div class="type_title">我要退款（无需退货）</div>
              <div class="type_txt">
                没收到货，或与卖家协商同意不用退货只退款
              </div>
            </div>
          </div>

          <div
            @click="type = 1"
            :class="[type == 1 ? 'xuanzhong' : '']"
            style="
              cursor: pointer;
              overflow: hidden;
              margin-top: 20px;
              float: left;
              margin-left: 20px;
            "
          >
            <div style="width: 320px; height: 80px; border: 1px solid #ede9e9">
              <div class="type_title">我要退货退款</div>
              <div class="type_txt">已收到货，需要退还收到的货物</div>
            </div>
          </div>
        </div>

        <div style="overflow: hidden; margin-top: 10px">
          <div
            @click="type = 2"
            :class="[type == 2 ? 'xuanzhong' : '']"
            style="
              overflow: hidden;
              margin-top: 20px;
              float: left;
              cursor: pointer;
            "
          >
            <div style="width: 320px; height: 80px; border: 1px solid #ede9e9">
              <div class="type_title">我要换货</div>
              <div class="type_txt">已收到货，需要更换已收到的货物</div>
            </div>
          </div>
        </div>
        <div class="clearfix" style="margin-top:30px">
          <a-upload
            action="/api/file/upload"
            list-type="picture-card"
            :file-list="fileList"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 6">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                点击上传
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
        <div
          style="
            width: 100%;
            height: 1px;
            margin: 20px 0;
            border-bottom: 1px dashed #ede9e9;
          "
        ></div>

        <div style="overflow: hidden">
          <div class="title">问题描述</div>
          <div class="rich_text_box" id="editorElem"></div>
        </div>

        <div @click="_tijiao" class="tijiao">提交</div> -->
                <div @click="_tijiao" class="tijiao">提交</div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
// 仪器耗材售后原因：仪器维修 | 破损丢失
const plainOptions = [
    { label: '质量问题', value: '质量问题' },
    { label: '特殊需求', value: '特殊需求' },
    { label: '使用问题', value: '使用问题' },
    { label: '包装问题', value: '包装问题' },
    { label: '破损问题', value: '破损问题' },
    { label: '运输丢失', value: '运输丢失' },
    { label: '数量短少', value: '数量短少' },
    { label: '其他问题', value: '其他问题' }
];
const options = [
    { label: '仪器维修', value: '仪器维修' },
    { label: '破损丢失', value: '破损丢失' }
];
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import E from 'wangeditor';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            // 多选
            plainOptions,
            options,
            value: [],
            value1: [],
            visible_shouhuo: false, //确认收货弹框
            //
            previewVisible: false,
            previewImage: '',
            type: 0,
            order_data: {},
            description: '',
            types: ['REFUNDS_RETURNS', 'ONLY_REFUNDS', 'EXCHANGE_GOODS'], //退换货，仅限退货，换货
            fileList: [],
            uuid: [],
            orderList: {},
            insex: 0,
            list: 0,
            returnGoodsState:false // 当用户完善了退货数量及退货原因就让同意退货
        };
    },
    mounted() {
        const editor = new E('#editorElem');
        // 上传
        // editor.customConfig.customUploadImg = (files, insert) => {
        //     const formData = new FormData();
        //     formData.append("file", files[0]);
        //     formData.append("path", "files/ne-icev3-dashboard/content/content/");
        //     axios.post("/public/index.php/test", formData).then(res => {
        //         const result = res.data;
        //         console.log(result);
        //         const data = result.data;
        //         insert(data);
        //     });
        // };
        // 赋值
        editor.config.onchange = res => {
            this.description = res;
        };
        editor.create();
    },
    methods: {
        handleOk() {
            this.order_data.ordersItemList[this.index].afterSale = this.orderList;
            this.order_data.ordersItemList[this.index].afterSale.images = this.uuid;
            if(this.orderList.returnNum > 0 && this.orderList.reason !== null){
                this.returnGoodsState = true;
                this.orderList = ''; // 当用户填写完整了再清空
                this.fileList = ''; // 当用户填写完整了再清空
                this.visible_shouhuo = false; // 当用户填写完整了再关闭弹框
            }else{
                this.$message.error('请完善售后原因及数量再提交')
                this.returnGoodsState = false;
            }
        },
        // 当用户点击取消时
        cancelShouhuo(){
            this.order_data.ordersItemList[this.index].afterSale = {applyAt:null,description: null,images:[],reason: null,returnNum: 0,type: null};
            this.order_data.ordersItemList[this.index].afterSale.images = [];
            this.$message.warning('请完善售后原因及数量再提交')
            this.visible_shouhuo = false;
        },
        updated(e, i) {
            console.log(e);
            this.list = e;
            this.orderList = e.afterSale;
            this.visible_shouhuo = true;
            this.index = i;
        },
        // 多选
        onChange(checkedValues) {
            // console.log('checked = ', checkedValues);
            // console.log('value = ', this.value);
        },
        onChange1(i) {
            // this.value.push(...this.value1)
            // console.log('checked1 = ', i);
            // // console.log('value = ', this.value);
            // console.log('value1 = ', this.value1);
        },
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
            let arr = [];
            this.fileList.forEach(e => {
                arr.push(e.response.data.uuid);
            });
            this.uuid = arr;
        },
        // 提交
        _tijiao() {
            let flag = false;
            this.order_data.ordersItemList.forEach(e => {
                if (e.afterSale.returnNum != 0) {
                    if (!e.afterSale.reason) {
                        this.$message.error(`请选择${e.productName}-${e.specification}商品退换原因`);
                        flag = false;
                    }
                }
            });
            // 判断当所有产品中任意一个退货产品有数量并且有退货原因就提交
            if(this.returnGoodsState){
                flag=true     
            }else{
                flag=false
                this.$message.error("请填写退货数量及售后原因");
            }
            // console.log(newNum,flag)
            if (flag) {
                this.api.tuihuandingdan(this.order_data).then(res => {
                    if (res.ok === true) {
                        this.$message.info(res.message);
                        this.$router.push('/order');
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
            // if(this.description == "") {
            //   this.$message.error('请输入问题描述')
            //   return false
            // }
            // console.log(this.fileList);
            // let reason = this.value.join(",") + ' ' + this.value1.join(",")
            // console.log(reason)
            // this.api.add_user_afterSale({ description: this.description, type: this.types[this.type], id: this.$route.query.uuid, images:this.uuid, reason:reason }).then(res => {
            //   if(res.ok) {
            //     console.log(res);
            //     this.$router.push('/order')
            //   }else {
            //     this.$message.error(res.message)
            //   }
            // })
        },
        // 获取订单进度
        get_order_jindu() {
            this.api.get_order_jindu(this.$route.query.uuid).then(res => {
                if (!res.ok) {
                    this.$message.error(res.message);
                    return false;
                }
                this.order_data = res.data;
            });
        }
    },
    created() {
        this.get_order_jindu();
    }
};
</script>

<style lang="less" scoped>
.goods_table_base_left1 {
    width: 150px;
    height: 100%;
    text-align: left;
    display: inline-block;
    background-color: #2b9a34;
}
.upfile_name{
    height: 111px;
}
.xuanzhong {
    border: 1px solid #2b9a34;
}
.goods_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.goods_title1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.box5 {
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
.type_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
    margin-left: 20px;
}

.type_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
    margin-left: 20px;
}
.rich_text_box {
    width: 90%;
    float: left;
    margin-top: 25px;
    margin-left: 2%;
    height: 400px;
    overflow: hidden;
}

.tijiao {
    width: 100px;
    height: 40px;
    /* border: 1px solid #2b9a34; */
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    float: right;

    background: #2b9a34;
    /* margin-left: 40px; */
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
}
.tijiao1 {
    display: inline-block;
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    position: absolute;
    right: 0;
    /* margin-left: 40px;
  margin-top: 40px;
  margin-bottom: 40px; */
    cursor: pointer;
}
.list-top {
    display: flex;
    margin-bottom: 14px;
    margin-left: 10px;
    .name {
        // width: 96px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
    }
    .CAS {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-left: 10px;
    }
}
.list-center {
    margin-left: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    margin-bottom: 14px;
}
.list-bottom {
    display: flex;
    margin-left: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2b9a34;
    line-height: 20px;
}
.text {
    flex-grow: 1;
}
.unwape {
    white-space: nowrap; /* 规定文本是否折行 */
    overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
}
.list {
    display: flex;
    width: 100%;
    position: relative;
    padding: 20px 0;
    border-bottom: 1px dashed #ede9e9;
}
</style>



// WEBPACK FOOTER //
// src/components/refund.vue